@if (!tab.showLoader) {
    <div menuSystem [cerrixTab]="tab" class="details" (changeEvent)="handleMenuItemClick($event)">
        <div class="detail-page-action-bar">
            @if (permissions.canEdit) {
                <button class="btn btn-cerrix" (click)="save()">
                    <i class="fas fa-save"></i>
                    <span data-uiid="save" class="d-none d-lg-inline">{{
                        "detail.savePeriod" | t
                    }}</span>
                </button>
            }

            <div class="workflow-area">
                @if (!model.dateClosed && permissions.canReopenPeriod) {
                    <button (click)="closePeriod()" class="btn btn-warning">
                        {{ "detail.closePeriod" | t }}
                    </button>
                }
            </div>
        </div>
        <div
            class="screens"
            menuItemId="menuItemPeriod"
            [attr.name]="'detail.menuPeriod' | t"
            menuicon="far fa-calendar-week"
            menusystemsubmenu
        >
            <div
                [attr.name]="'detail.menuDetails' | t"
                menuItemId="universe-period-detail"
                menuicon="fas fa-info-circle"
                menusystemitem
            >
                <audit-universe-period-detail-main
                    [permissions]="permissions"
                    [parentForm]="parentForm"
                    [model]="model"
                >
                </audit-universe-period-detail-main>
            </div>
            @if (permissions.canViewHistory) {
                <div
                    [attr.name]="'detail.menuHistory' | t"
                    menuItemId="history"
                    menuicon="fas fa-history"
                    menusystemitem
                >
                    <app-history-overview
                        [Id]="model.guid"
                        [historyDataService]="_ds"
                        #historyDetailOverviewComponent
                    ></app-history-overview>
                </div>
            }
            @if (permissions.canDelete) {
                <div
                    menuItemId="menuItemOptions"
                    [attr.name]="'detail.menuOptions' | t"
                    menuicon="fas fa-check-double"
                    menusystemitem
                >
                    <detail-options
                        moduleName="audit period"
                        [objectName]="model.name"
                        [allowDelete]="true"
                        (onDelete)="delete()"
                    >
                    </detail-options>
                </div>
            }
        </div>
    </div>
}
